import { BaseFilter } from 'src/app/sharedFeatures/models/base-filter.model';

export class NotificationSearchModel {
  // Match UINotificationFilters from ChecklistFlow API
  status?: number | null; // 1 = New/Unseen, 2 = Seen
  userId?: string | null;
  count?: number = 20;
}
